import React from 'react'
import ForgotPasswordForm from "./ForgotPasswordForm";
import ConfirmForgotPasswordForm from "./ConfirmForgotPasswordForm";

export interface ForgotPasswordProps {
  onSuccess: () => void
}

export const ForgotPassword = ({onSuccess, ...props}:ForgotPasswordProps) => {
  const [username, setUsername] = React.useState('');
  const [step, setStep] = React.useState('send');

  const handleSendForgotPassword = (username:string) => {
    setUsername(username);
    setStep('confirm');
  }

  const handleForgotPasswordConfirm = () => {
    onSuccess();
  }

  switch(step) {
    case 'confirm':
      return (
        <ConfirmForgotPasswordForm username={username} onSuccess={handleForgotPasswordConfirm} />
      );
    default:
      return (
        <ForgotPasswordForm onSuccess={handleSendForgotPassword} />
      );
  }
}